import { render, staticRenderFns } from "./home.vue?vue&type=template&id=4d94663d&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=4d94663d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94663d",
  null
  
)

export default component.exports